import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'etxe-agent-bio-display',
  imports: [],
  templateUrl: './agent-bio-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentBioDisplayComponent {
  readonly bio = input<string | undefined>(undefined);
}
